const sidebarItems = [
  /* {
    name: "Dashboard",
    path: "/dashboard",
    icon: "ni ni-tv-2 text-primary",
    allowedRoles: [
      "customer",
      "admin",
      "surveyor",
      "sampler",
      "preparator",
      "tester",
      "technical-manager",
      "document-manager",
      "super-admin",
    ],
  }, */

  {
    name: "Users",
    path: "/users",
    icon: "ni ni-single-02 text-yellow",
    allowedRoles: [
      // "customer",
      // "admin",
      // "surveyor",
      // "sampler",
      // "preparator",
      // "tester",
      // "technical-manager",
      // "document-manager",
      "super-admin",
    ],
  },
  {
    name: "Parameters",
    path: "/parameters",
    icon: "ni ni-collection text-primary",
    allowedRoles: [
      // "customer",
      // "admin",
      // "surveyor",
      // "sampler",
      // "preparator",
      // "tester",
      // "technical-manager",
      // "document-manager",
      "super-admin",
    ],
  },

  {
    name: "Orders",
    path: "/orders",
    icon: "ni ni-bullet-list-67 text-red",
    allowedRoles: [
      "customer",
      "admin",
      "surveyor",
      "sampler",
      "preparator",
      "tester",
      "technical-manager",
      // "document-manager",
      // "super-admin",
    ],
  },

  {
    name: "Documents",
    path: "/documents",
    icon: "ni ni-book-bookmark text-blue",
    allowedRoles: [
      // "customer",
      // "admin",
      // "surveyor",
      // "sampler",
      // "preparator",
      // "tester",
      // "technical-manager",
      "document-manager",
      // "super-admin",
    ],
  },

  /* {
    name: "Questions",
    path: "/questions",
    icon: "ni ni-bulb-61 text-yellow",
    allowedRoles: [
      "customer",
      "admin",
      "surveyor",
      "sampler",
      "preparator",
      "tester",
      "technical-manager",
      "document-manager",
      "super-admin",
    ],
  }, */
];

const sideBarLinks = (role) =>
  sidebarItems.filter((item) => item.allowedRoles.includes(role));

export default sideBarLinks;
